import { metricsBus } from "@/common/buses";
import { useEffect } from "react";

export const useTrackPWA = () => {
  const isPWA = window.matchMedia("(display-mode: standalone)").matches;

  useEffect(() => {
    if (isPWA) {
      metricsBus.emit("PWASessionStarted");
    }
  }, [isPWA]);
};
